import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { DriverDeliveryHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/driver/driver-delivery-hdr-container.model';



@Injectable({
  providedIn: 'root'
})
export class DriverHdrService extends BaseApiTemplateService<DriverDeliveryHeaderContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/drivers
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/drivers';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/drivers';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/drivers';
    this.httpClient = http;
  }
}
